const CashRegisterGrid = {
    init: () => {
        $.nette.ext("initOnAjax", {
            success: function (payload) {
                if (!payload.redirect) {
                    CashRegisterGrid.jsInit();
                }
            }
        });

        CashRegisterGrid.jsInit();
    },

    jsInit: () => {
        const tableRows = $('.datagrid tbody tr');
        const checkboxes = tableRows.find('input[type="checkbox"]');

        checkboxes.on('change', function () {
            CashRegisterGrid.updateAmountSums(checkboxes);
        })
        CashRegisterGrid.updateAmountSums(checkboxes);
    },

    showAmountSums: (innerHtml) => {
        $('#amountSums .alert-content').html(innerHtml);
        $('#amountSums').removeClass('hidden');
    },

    hideAmountSums: () => {
        $('#amountSums .alert-content').html('');
        $('#amountSums').addClass('hidden');
    },

    updateAmountSums: (inputs) => {
        const checkedInputs = inputs.filter(':checked');

        if (checkedInputs.length === 0) {
            CashRegisterGrid.hideAmountSums();
            return;
        }

        let sums = {};

        checkedInputs.each(function () {
            const parentTableRow = $(this).closest('tr');
            const rowCurrency = parentTableRow.data('currency');
            const rowAmount = parseFloat(parentTableRow.data('amount'));

            if (rowCurrency in sums) {
                sums[rowCurrency] += rowAmount;
            } else {
                sums[rowCurrency] = rowAmount;
            }
        });

        let html = '';

        Object.keys(sums).forEach(function (currency) {
            html = html + '<div class="col-sm-12">' + formatMoney(sums[currency], currency) + '</div>';
        });

        CashRegisterGrid.showAmountSums(html);
    }
}

window.cashRegister = { cashRegisterGrid: CashRegisterGrid };
